import { createClient } from '@supabase/supabase-js';
import { projectId, publicAnonKey } from './info';

const supabaseUrl = `https://${projectId}.supabase.co`;
const supabaseKey = publicAnonKey;

export const supabase = createClient(supabaseUrl, supabaseKey);

(window as any).__testParticipants = async (email: string) => {
  const e = (email || '').trim().toLowerCase();
  const { data, error } = await supabase
    .from('participants')
    .select('id, group_id, name, email')
    .eq('email', e);
  console.log('participants by email', e, { data, error });
};
